import { FormField } from 'ui/formField';
import { TriggerEventGroups } from './TriggerEventGroups';
import { SystemWebhookFormState } from '../types';

export const TriggerEventGroupsFormField = ({
  webhook,
  updateWebhook,
}: {
  webhook: SystemWebhookFormState;
  updateWebhook: (field: string, value: string[]) => void;
}) => {
  return (
    <FormField inputId="webhookTriggerEvents">
      <TriggerEventGroups
        // @ts-ignore
        onCheckboxChange={(value) => updateWebhook('enabledEvents', value)}
        defaultChecked={webhook.enabledEvents}
      />
    </FormField>
  );
};
